<template>
  <div>
    <v-row>
      <v-col
        v-if="!addingImages && !onlyGallery"
        cols="12"
        sm="12"
        md="12"
      >
        <v-btn
          @click="enableAddImage()"
        >
          Add Images
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="download">
      <v-col
        cols="12"
        sm="12"
        md="12"
      >
        <v-card
          v-if="ticketHasImages"
        >
          <v-list dense>
            <v-list-subheader>
              <h3>Images (click to download)</h3>
            </v-list-subheader>
            <v-list-item
              v-for="(image, i) in ticketImages"
              :key="i"
            >
              <OpsTicketDownloadImage
                :image="image"
                :show-type="showType"
              />
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="!download">
      <v-col
        v-if="images.length"
        cols="12"
        sm="12"
        md="12"
      >
        <VuePictureSwipe :items="images" />
      </v-col>
      <v-col
        v-if="addingImages && !onlyGallery"
        cols="12"
        sm="12"
        md="12"
      >
        <v-file-input
          v-model="files"
          multiple
          label="Select Images"
          accept="image/*"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VuePictureSwipe from 'vue3-picture-swipe';
import OpsTicketDownloadImage from '@/views/Helpdesk/components/OpsTicketDashboard/OpsTicketDownloadImage.vue';

export default {
  name: 'OpsTicketImages',
  components: {
    OpsTicketDownloadImage,
    VuePictureSwipe,
  },
  props: {
    onlyGallery: {
      type: Boolean,
      required: false,
      default: false,
    },

    download: {
      type: Boolean,
      required: false,
      default: false,
    },

    ticketImages: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },

    resetImages: {
      type: Boolean,
      required: false,
      default: false,
    },

    showType: {
      type: String,
      required: false,
      default: 'ticket',
    },
  },

  emits: ['restartReset', 'input'],

  data() {
    return {
      addingImages: false,
      files: [],
      images: [],
    };
  },

  computed: {
    ticketHasImages() {
      return this.ticketImages && this.ticketImages.length;
    },
  },

  watch: {
    files(newFiles) {
      this.initImagesFromUploadInput(newFiles);
    },

    resetImages(value) {
      if (value) {
        this.files = [];
        this.images = [];
        this.addingImages = false;
        this.$emit('restartReset');
      }
    },
  },

  methods: {
    enableAddImage() {
      this.addingImages = true;
    },

    initImagesFromUploadInput(newFiles) {
      this.images = [];

      newFiles.forEach((file) => {
        const reader = new FileReader();

        reader.onload = (e) => {
          this.images.push({
            src: e.target.result,
            w: 0,
            h: 0,
            thumbnail: e.target.result,
            tW: 60,
            tH: 40,
          });
        };

        reader.readAsDataURL(file);
      });

      this.$emit('input', this.files);
    },
  },
};
</script>

<style>
#file-input .v-input__icon--append {
  display: none;
}

.v-application--is-ltr .v-input__prepend-outer {
  margin-top: 10px;
}

.my-gallery {
  display: flex;
  justify-content: start;
  align-items: center;
  height: 75px;
  overflow-y: auto;
  min-height: 135px;
  padding: 10px;
  background-color: rgba(0, 0, 0, 75%);
}

.gallery-thumbnail img {
  width: 100px;
  opacity: 1;
}
</style>
